(function($) {
    $(() => {

        const settings = {
            maxZoom: 22,
            minZoom: 11,
            attribution: '',
            subdomains: 'abcd',
        };

        if($('#map').length) {

            var osm = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', settings);
        
            var map = L.map('map', {
                center: [47.5344969, 19.0666449],
                zoom: 13,
                scrollWheelZoom: false
            });

            map.addLayer(osm);

            $.each(cat, function(i, item) {
                window[cat[i]] = L.layerGroup();
            });

            locations.forEach(element => {

                var icon = L.divIcon({
                    className: 'custom-div-icon',
                    html: "<img src='"+ ajax.themeurl +"/assets/img/map/"+ cat[element[3]] +".svg' ><div class='marker-pin'></div>",
                    iconSize: [48, 48],
                });

                var cords_array = element[2].split(',');
                cords_array = $.map(cords_array, function(s){ return parseFloat(s); });
                var marker = L.marker(cords_array, { icon: icon }).bindPopup(element[1]);
                marker.addTo(window[cat[element[3]]]);
            });
        
            var mcgLayerSupportGroup = L.markerClusterGroup.layerSupport();
            mcgLayerSupportGroup.addTo(map);

            $.each(cat, function(i, item) {
                mcgLayerSupportGroup.checkIn([window[cat[i]]]);
                map.addLayer(window[cat[i]]);
            });

            $('.js-cat-check').on('change', function() {
                if ($(this).prop('checked')==true){ 
                    map.addLayer(window[$(this).data('cat')]);
                } else {
                    map.removeLayer(window[$(this).data('cat')]);
                }
            });
        }

        /* 
        DOUBLE MAP SECTION
        */

        if($('.section-double-map').length) {
            var icon_img = L.divIcon({
                className: 'custom-div-icon-img',
                html: "<img src='"+ ajax.themeurl +"/assets/img/map/map_pin.svg' >",
                iconSize: [48, 48],
            });
    
            var osm_1 = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', settings);
    
            var map_1 = L.map('map_1', {
                center: [$('#map_1').data('lat'), $('#map_1').data('lng')],
                zoom: 13,
                scrollWheelZoom: false
            });
    
            map_1.addLayer(osm_1);
    
            var marker_1 = L.marker([$('#map_1').data('lat'), $('#map_1').data('lng')], { icon: icon_img }).bindPopup($('#map_1').data('text'));
    
            marker_1.addTo(map_1);
    
            var osm_2 = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', settings);
    
            var map_2 = L.map('map_2', {
                center: [$('#map_2').data('lat'), $('#map_2').data('lng')],
                zoom: 13,
                scrollWheelZoom: false
            });
    
            map_2.addLayer(osm_2);
    
            var marker_2 = L.marker([$('#map_2').data('lat'), $('#map_2').data('lng')], { icon: icon_img }).bindPopup($('#map_2').data('text'));
    
            marker_2.addTo(map_2);
        }

    
    });
})(jQuery);
    